import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextButtonDisabled = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Disabled Text button"}
        value={'<Button variant={"text"} disabled>Disabled</Button>'}
      >
        <Button variant={"text"} disabled>
          Disabled
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TextButtonDisabled;
